import styled from 'styled-components'

interface ButtonProps {
  disabled?: boolean
}

export const Button = styled.button<ButtonProps>`
  outline-color: #002d63;
  width: '100%';
  height:  '100%';
  border: 1px solid #c7c9c7;
  border-radius: 4px;
  color: #ffffff;
  background-color: ${({ disabled }) => (disabled ? '#bbbbbb' : '#25a37b')};
  font-weight: bold;
`
